import React from 'react';
import styled from 'styled-components';
import { ScreenReaderText } from '@peloton/accessibility/screenReaderOnly';
import scrollToTop from '@peloton/navigation/scrollToTop';
import { slate1, white } from '@engage/colors';
import { spaces } from '@engage/styles';
import { label4Large, capsLabel5Large } from '@engage/typography';
import { ClassesCopy } from '@members/copy';
import { Classes } from '@members/copy/models.generated/Classes';

const ClearFilters: React.FC<React.PropsWithChildren<Props>> = ({
  appliedFilterCount,
  onClick,
}) =>
  appliedFilterCount > 0 ? (
    <ClearButton
      data-test-id="clearFilterButton"
      onClick={() => {
        onClick();
        scrollToTop();
      }}
    >
      <ClassesCopy id={Classes.ClearFilters} />
      <AppliedCount data-test-id="filterCount" aria-hidden={true}>
        {appliedFilterCount}
      </AppliedCount>
      <ScreenReaderText>
        <ClassesCopy
          id={Classes.ClearCountScreenReader}
          values={{ appliedFilterCount }}
        />
      </ScreenReaderText>
    </ClearButton>
  ) : null;

const ClearButton = styled.button`
  ${label4Large};
  align-items: center;
  color: ${slate1};
  display: flex;
  margin-left: ${spaces.large}px;
`;

const AppliedCount = styled.div`
  background-color: ${slate1};
  ${capsLabel5Large}
  padding: ${spaces.tiny}px;
  color: ${white};
  text-align: center;
  line-height: 1em;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  margin-left: ${spaces.xxSmall}px;
`;

type Props = {
  appliedFilterCount: number;
  onClick(): void;
};

export default ClearFilters;
